module.exports = __webpack_public_path__ + "static/media/nationals-seating-map.2bc4849e.svg";